// ConditionalWhatsAppButton.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import WhatsAppButton from './WhatsAppButton';

const ConditionalWhatsAppButton = () => {
  const location = useLocation();
  
  // Liste des routes où WhatsApp ne doit pas apparaître
  const excludedRoutes = [
    '/login-admin',
    '/admin',
    '/admin/',
    '/admin/dashboard',
    '/admin/users',
    // Ajoutez toutes vos routes admin ici
  ];

  const shouldShowWhatsApp = !excludedRoutes.some(route => 
    location.pathname.startsWith(route)
  );

  if (!shouldShowWhatsApp) {
    return null;
  }

  return <WhatsAppButton />;
};

export default ConditionalWhatsAppButton;